import utils from '@/mixins/utils.js'

export const dataFieldsDia = {
  Dia: 'nu_dia',
  Alta: 'alta',
  Intermediária: 'intermediaria',
  Baixa: 'baixa',
  'Não aguda': 'nao_aguda',
  'Sem classificação': 'sem_classificacao',
  'Total do dia': 'total_do_dia',
}

export const dataFieldsMes = {
  Classificação: 'classificacao',
  Quantidade: 'quantidade',
}

export const dataFieldsEspera = {
  Minutos: 'faixa_tempo_atendimento',
  Quantidade: 'qtd_atendimentos',
}

export const dataFieldsClassificacao = {
  'Tempo de espera': 'tempo_espera',
  '<15': '<15',
  '>15 <30': '>15 <30',
  '>30 <60': '>30 <60',
  '>60 <120': '>60 <120',
  '>120 <240': '>120 <240',
  '>240': '>240',
}

export const infoHtml = ``
